export const allow_list = [
  'device_renewal',
  'abnormal_behaviour',
  'body_score',
  'analysis.lactose_percentage',
  'analysis.solid_percentage',
  'analysis.urea',
  'answered_at',
  'birth_events',
  'calf_status',
  'calves',
  'calving_procedure',
  'cancellation_reason',
  'clinical_opinion_text',
  'comment',
  'comments',
  'complication',
  'condition',
  'confirmed_at',
  'confirmed_by',
  'confirmer_name',
  'confirmer.name',
  'contract_first_payment',
  'creator',
  'created_at',
  'created_item_at',
  'creator_name',
  'creator.name',
  'death_method_text',
  'death_method',
  'death_reason_text',
  'death_reason',
  'deleted_at',
  'departure_kind',
  'departure_reason',
  'description',
  'designer.name',
  'detected_at',
  'diagnostic.name_text',
  'diagnostic',
  'donor',
  'dosage',
  'dry_reason',
  'embryo_type_text',
  'extra',
  'farm_new_semen.name',
  'fidelity',
  'financing_modality',
  'foetus_text',
  'from_algorithm',
  'gender',
  'handling',
  'health_completion_type',
  'heat_detection_method_text',
  'heat_detection_method',
  'heat_intensity_text',
  'heat_intensity',
  'heat_signs_text',
  'heat_signs',
  'inseminator_name',
  'inseminator.name',
  'installed_by',
  'international_register',
  'last_processed_at',
  'mammary_quarter',
  'mastitis_causative_agent',
  'mastitis_intensity_level',
  'meat_return',
  'method_text',
  'milking_return',
  'milkings.milking_0',
  'milkings.milking_1',
  'milkings.milking_2',
  'milkings.milking_3',
  'moderation_comment',
  'observation',
  'order_date',
  'penultimate_event_clinical_opinion',
  'penultimate_event_comment',
  'ppi_status',
  'processed_at',
  'reason_text',
  'received_at',
  'negotiated_condition',
  'responsible.name',
  'cancellation_motive_text',
  'recommendation',
  'register',
  'relevant_event_comment',
  'relevant_event_timestamp',
  'restored',
  'semen_label',
  'semen_type_text',
  'semen.label',
  'semen',
  'signals_and_symptoms',
  'term_of_contract',
  'treated',
  'treatment',
  'treatments',
  'updated_at',
  'user.name',
  'with_anormal_behavior',
  'with_ftai',
  'with_heat',
] as const

export type AllowList = (typeof allow_list)[number]
